<template>
<div>
  <!-- <Head /> -->
  <div class="policy">
    <div class="banner"><img src="" width="100%"></div>
    <div class="policy-head">
      <a style="text-decoration:none; color:#555;" href="" title="网站首页">网站首页</a>
      >
      <a style="margin-left: 0px;text-decoration:none;color:#555;" href="" title="政策动态">政策动态</a>
      >
    </div>
    <ul class="policy-list">
      <li
        v-for="(art, idx) in newList"
        :key="'article-'+idx"
        :class="{listitem:true,listitemer:listitemershow}"
      >
        <div class="img">
          <router-link :to="'/policy/view/'+art.tid">
          <img style="width:100%;height:120px" :src="art.photo" alt="">
          </router-link>
        </div>
        <div class="con">
          <router-link class="atitle"
          :to="'/policy/view/'+art.tid">{{art.title}}</router-link><br>
          <span>发布时间:{{art.created}}</span>
          <p>{{art.brief}}</p>
        </div>
      </li>
      <!-- <div class="list-pager"> -->
        <Page :current="page" :total="totalPage" :page-size="pageSize" @on-change="changePage" style="margin: 40px auto 20px auto; text-align: center;"  />
      <!-- </div> -->
    </ul>
    <!-- <router-view :informationList="policyList" /> -->
  </div>
  <!-- <Footer /> -->
</div>
</template>

<script>
// import policyList from './policies.json'
// import Footer from '../../components/footer.vue'
// import Head from '../../components/head.vue'
export default {
  props: ['informationList'],
  components: {
    // Head,
    // Footer,
  },
  data () {
    return {
      page: 1,
      totalPage: 0,
      pageSize: 8,
      count: 0,
      newList: [],
      listitemershow: false
      // policyList: []
    }
  },
  watch: {
    'informationList': function (newVal) {
      // this.informationList.sort((a, b) => {
      //   return new Date(b.created).getTime() - new Date(a.created).getTime()
      // })
      this.renderList()
    }
  },
  mounted () {
    this.renderList()
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll () {
      this.currentScroll = window.pageYOffset
      if (this.currentScroll >= 200) {
        this.listitemershow = true
      }
    },
    renderList () {
      this.totalPage = this.informationList instanceof Array ? this.informationList.length : 0
      this.pageSize = 5
      this.newList = this.informationList.filter((item, index) => {
        return index < this.page * this.pageSize && index >= this.pageSize * (this.page - 1)
      })
    },
    changePage (page) {
      this.page = page
      this.renderList()
    },
    formatDate (data, digits, mask) {
      digits = digits || 2
      mask = mask || '0'
      // return leftPad(data, digits, mask)
    }
  }
}
</script>

<style lang="less" scoped>
@import url('../../../static/less/less.css');
@media only screen and (min-width: 479px) {
  .con {
    .atitle {
      font-size: 16px;
    }
    span {
      font-size: 14px;
    }
    p {
      font-size: 14px;
      // overflow: hidden;
      // text-overflow: ellipsis;
      // margin-top: 5px;
      overflow: hidden;
      text-overflow: ellipsis;
      height: 45px;
    }
  }
}
@media only screen and (max-width: 479px) {
  .con {
    .atitle {
      font-size: 13px;
    }
    span {
      display: none;
    }
    p {
      overflow: hidden;
      text-overflow: ellipsis;
      height: 54px;
      font-size: 12px;
      margin-top: 5px;
    }
  }
}
a {
  color: #999;
}
.policy {
  width: 96%;
  max-width: 1200px;
  margin: 0 auto;
  // min-width: 1200px;
  position: relative;
  padding: 40px 0 50px 0;
  // margin: 0 10%;
  // width: 75%;
  .policy-head {
    border: #E6E6E6 solid 1px;
    height: 40px;
    line-height: 22px;
    font-size: 14px;
    padding-top: 10px;
    color: #62615F;
    a {
      margin-left: 30px;
      color: #555;
      font-weight: normal;
      font-size: 14px;
    }
  }
  .policy-list {
    // padding: 0 10px;
    // height: 60px;
    // border-bottom: 1px solid #ddd;
    // line-height: 60px;
    .listitemer {
      animation-name: fadeUp;
      visibility: visible;
      animation-duration: 2s;
      opacity: 1 !important;
    }
    .listitem {
      padding-top: 30px;
      padding-left: 20px;
      border-bottom: #E6E6E6 solid 1px;
      border-left: #E6E6E6 solid 1px;
      border-right: #E6E6E6 solid 1px;
      height: 180px;
      overflow: hidden;
      opacity: 0;
    // border-bottom: 1px solid #ddd;
    .img {
      float: left;
      width: 16%;
    }
    .con {
      float: left;
      width: 70%;
      padding-left: 20px;
      .atitle {
        text-decoration:none;
        // font-size: 16px;
        font-weight: bold;
        color: #000;
      }
      span {
        color: #666;
        // font-size: 14px;
        line-height: 25px;
      }
      p {
        color: #999;
        // font-size: 14px;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // height: 54px;
      }
    }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/policy/policy-list.vue